<nb-card>
    <nb-card-header>{{ title }}</nb-card-header>
    <nb-card-body>{{ message }}</nb-card-body>
    <nb-card-footer class="button-row">
      <button nbButton status="basic" (click)="cancel()">{{ cancelLabel }}</button>
      <button nbButton status="primary" (click)="confirm()">{{ confirmLabel }}</button>
    </nb-card-footer>
</nb-card>